import { Component, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { ADS } from "../config/ads";

const SIZES = {
  leaderboard: { label: "728x90 / 320x100", box: "h-[100px] w-[320px] md:h-[90px] md:w-[728px]" },
  slim: { label: "728x90 / 320x50", box: "h-[50px] w-[320px] md:h-[90px] md:w-[728px]" },
};

const inject = (container, code) => {
  container.innerHTML = "";
  const tpl = document.createElement("template");
  tpl.innerHTML = code;
  tpl.content.querySelectorAll("script").forEach((old) => {
    const s = document.createElement("script");
    Array.from(old.attributes).forEach((a) => s.setAttribute(a.name, a.value));
    s.text = old.textContent;
    old.replaceWith(s);
  });
  container.appendChild(tpl.content);
};

const AdCode = ({ code, boxClass }) => {
  const ref = useRef(null);
  const { pathname, search } = useLocation();
  useEffect(() => {
    const el = ref.current;
    try {
      inject(el, code);
    } catch (e) {
      console.warn("Ad slot failed", e);
    }
    return () => {
      el.innerHTML = "";
    };
  }, [code, pathname, search]);
  return <div ref={ref} className={`mx-auto flex max-w-full items-center justify-center overflow-hidden ${boxClass}`} />;
};

class AdErrorBoundary extends Component {
  state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  componentDidCatch(e) {
    console.warn("Ad slot crashed", e);
  }
  render() {
    return this.state.failed ? null : this.props.children;
  }
}

const AdSlotInner = ({ name, size = "leaderboard", className = "" }) => {
  const { search } = useLocation();
  const slot = ADS[name];
  const { label, box } = SIZES[size];
  const preview = new URLSearchParams(search).get("ads") === "preview";
  if (!slot?.enabled) return null;
  const code = slot.code.trim();
  if (!code && !preview) return null;

  return (
    <div data-testid={`ad-slot-${name}`} className={`mx-auto flex max-w-7xl flex-col items-center px-5 py-6 md:px-10 ${className}`}>
      <span className="mb-2 text-[10px] uppercase tracking-[0.25em] text-neutral-600">Advertisement</span>
      {code ? (
        <AdCode code={code} boxClass={box} />
      ) : (
        <div
          data-testid={`ad-slot-${name}-placeholder`}
          className={`mx-auto flex max-w-full items-center justify-center rounded-lg border border-dashed border-[#D4AF37]/50 bg-[#D4AF37]/[0.04] text-center text-xs uppercase tracking-[0.18em] text-[#D4AF37]/80 ${box}`}
        >
          Ad Space – {name} ({label})
        </div>
      )}
    </div>
  );
};

export const AdSlot = (props) => (
  <AdErrorBoundary>
    <AdSlotInner {...props} />
  </AdErrorBoundary>
);
